// extracted by mini-css-extract-plugin
export default {"wrapper":"ModalAddRole_wrapper__m4fy6","contain":"ModalAddRole_contain__tZHJP"};